<template>
  <el-header class="header">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item, index) in breadcrumb" :key="item.path">
          <a v-if="index < breadcrumb.length - 1" @click="breadBack(index)" class="pointer">{{ item.title }}</a>
          <span v-else>{{ item.title }}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="user">
      <el-dropdown @command="handleCommand" trigger="click">
        <div class="user-info">
          <el-avatar :size="24" :src="`${$fileBaseUrl}/24x24/${user.userLogo}`">
            <img :src="`${$ssoUrl}/images/user/logo.png`" />
          </el-avatar>
          <span class="user-name">{{ user.realName || account }}</span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="4">
            <div class="drop-down-my">
              <i class="el-icon-setting icon-down"></i>
              <span>退出系统</span>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-header>
</template>

<script>
import CacheService from "@/service/catch";
import { mapState } from "vuex";

export default {
  data() {
    return {
      user: "",
      account: "",
      logo: "",
      titleName: "",
    };
  },
  created() {
    // this.getConfig();
  },
  mounted() {
    this.user = this.$store.state.user;
    this.account = CacheService.get("account");
  },
  computed: {
    ...mapState(["breadcrumb"]),
  },
  watch: {
    "$store.state.user"(n, o) {
      //普通的watch监听
      this.user = n;
    },
  },
  methods: {
    // async getConfig() {
    //   const logo = require("../../src/assets/img/project-icon.png");
    //   try {
    //     const data = await this.$axios.get(`/OpencloudManager/Platform/PlatformConfigByKey?key=scmpc&moduleType=1`);
    //     this.logo = data.content ? this.$fileBaseUrl + "30x30/" + data.content : logo;
    //     this.titleName = data.name;
    //     data.name && (document.title = data.name);
    //   } catch (e) {
    //     this.logo = logo;
    //     document.title = this.titleName;
    //   }
    // },
    handleCommand(command) {
      let that = this;
      switch (command) {
        case "4":
          that.layout();
          break;
        default:
          break;
      }
    },
    layout() {
      this.$confirm("确定要退出当前用户吗?", "退出登录", {
        confirmButtonText: "退出",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.clearStorage();
          this.logOut();
        })
        .catch(() => {});
    },
    clearStorage() {
      CacheService.clear();
      this.$store.state.comp = "";
      this.$store.state.compList = [];
      this.$store.state.user = {};
      this.$store.state.menu = [];
      this.$store.state.auth = [];
      this.$store.state.breadcrumb = [];
      this.$store.state.activeName = "";
    },
    logOut() {
      // top.location=`${this.$ssoUrl}/Acount/Logout?returnUrl=${this.$localUrl}`;
      window.close();
    },
    breadBack(index) {
      const backLen = this.breadcrumb.length - index - 1;
      this.$router.go(-backLen);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px #eaecf1 solid;
  padding: 0 !important;
  height: 50px !important;
  .breadcrumb {
    padding: 20px 25px;
    line-height: 18px;
    align-items: center;

    .el-breadcrumb {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #181d31;

      /deep/ .el-breadcrumb__inner {
        color: #181d31;
      }
    }

    .el-icon-arrow-left {
      cursor: pointer;
    }
  }
  .user {
    display: flex;
    border-radius: 15px;
    height: 45px;
    opacity: 1;
    align-items: center;
    margin-right: 15px;

    .user-info {
      display: flex;
      cursor: pointer;
      padding: 0 15px;
    }
    .user-name {
      margin-left: 8px;
    }
  }
}
</style>
